export enum SizingDialogMode {
  CREATE_WITH_EXISTING = 'CREATE_WITH_EXISTING',
  CREATE_EMPTY = 'CREATE_EMPTY',
  SUBMIT = 'SUBMIT'
}